var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex"},[_c('div',{attrs:{"id":"soap-loading-menu"}},[_c('loader')],1),_c('div',{attrs:{"id":"soap-loading-menu-divider"}}),_c('div',{attrs:{"id":"soap-loading-content"}},[_c('loader')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }